import { render, staticRenderFns } from "./form-submission-download-stamped-pdf-btn.vue?vue&type=template&id=16179004"
import script from "./form-submission-download-stamped-pdf-btn.vue?vue&type=script&lang=js"
export * from "./form-submission-download-stamped-pdf-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports